let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fW8Hg")).then(() => parcelRequire('5ws4u'));